'use client';

import { FileEdit } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface MemosListProps {
  onTogglePreview: () => void;
  memoCount?: number;
  className?: string;
}

/**
 * MemosList - Icon-only button to toggle memos preview
 * Simplified from dropdown to match Claude Artifacts pattern
 */
export function MemosList({ onTogglePreview, memoCount = 0, className }: MemosListProps) {
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onTogglePreview}
      className={cn('h-7 px-2 relative', className)}
      title="View recent memos"
    >
      <FileEdit className="w-4 h-4" />
      {memoCount > 0 && (
        <span className="absolute -top-1 -right-1 h-4 w-4 rounded-full bg-accent-blue-500 text-white text-[10px] font-medium flex items-center justify-center">
          {memoCount > 9 ? '9+' : memoCount}
        </span>
      )}
    </Button>
  );
}
